<template>
    <div class="base-info">
        <div class="base-info__img">
            <img v-if="baseInfo.imgUrl" class="img" :src="baseInfo.imgUrl"/>
            <img v-else class="img" src="@/assets/images/default-img.png"/>
        </div>
        <div class="base-info__content">
            <div class="base-info__content--title">{{ baseInfo.title | defaultShow }}</div>
            <div class="base-info__content--asin">
                <span>ASIN: <em class="value" style="cursor: pointer;" @click="navigateTo(baseInfo.asinUrl)">{{ baseInfo.asin | defaultShow }}</em></span>
                <span>父ASIN: <em class="value" style="color: #666666;">{{ baseInfo.parentAsin | defaultShow }}</em></span>
            </div>
            <div class="base-info__content--ranking">
                <el-rate :value="Number(baseInfo.star)" disabled></el-rate>
                <span>{{ baseInfo.star | defaultShow }}（{{ baseInfo.starQuantity | defaultShow }}）</span>
                <span>销售排名：{{ baseInfo.sellerRank | defaultShow }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { getListingInfo } from '@/api/statistics'
    export default {
        name: "statistics-base-info",
        inject: ['getPageParams', 'generatorPageParams'],
        data () {
            return {
                baseInfo: {}
            }
        },
        computed: {
            pageParams () {
                return this.getPageParams()
            }
        },
        created () {
            this.getListingInfo()
        },
        methods: {
            /**
             * 获取基本信息
             */
            getListingInfo () {
                let params = this.generatorPageParams(this.pageParams)
                getListingInfo(params).then((res = {}) => {
                    this.baseInfo = Object.assign({}, this.baseInfo, res)
                })
            },
            navigateTo (url = '') {
                if (url) {
                    window.open(url, '_blank')
                }
            },
            /**
             * 刷新
             */
            refresh () {
                this.getListingInfo()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .base-info {
        border-radius: 2px;
        border: 1px solid #EBEEF5;
        overflow: hidden;
        transition: 0.3s;
        display: flex;
        padding: 10px;
        background: #ffffff;
        &__img {
            position: relative;
            width: 110px;
            height: 110px;
            .img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: center;
            }
        }

        &__content {
            margin-left: 13px;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            font-size: 14px;
            font-weight: bold;
            &--title {
                color: #333333;
            }

            &--asin {
                color: #666666;

                > span {
                    margin-right: 22px;

                    .value {
                        color: #1F6EEF;
                        font-style: normal;
                    }
                }
            }

            &--ranking {
                display: flex;
                color: #666666;

                > span {
                    margin-left: 10px;
                }
            }
        }
    }
</style>
